import { equals, propOr } from 'rambda'

export default (original, incoming) => Object
  .entries(incoming)
  .some(([key, value]) => !equals(value, propOr(null, key, original)))
